import { render, staticRenderFns } from "./BlockCarousel.vue?vue&type=template&id=1baa4662"
import script from "./BlockCarousel.vue?vue&type=script&lang=js"
export * from "./BlockCarousel.vue?vue&type=script&lang=js"
import style0 from "./BlockCarousel.vue?vue&type=style&index=0&id=1baa4662&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports